import { render, staticRenderFns } from "./ContractAdditionalPayments.vue?vue&type=template&id=4ac20355"
import script from "./ContractAdditionalPayments.vue?vue&type=script&lang=js"
export * from "./ContractAdditionalPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports